import { trackEvent, eventNameConstants } from 'dibs-tracking';

export const CATEGORY = 'contact 1stdibs';

export const LIVE_CHAT_ACTION_MAP = {
    buttonDisplayed: 'live chat button displayed',
    invitationDisplayed: 'live chat invitation displayed',
    offline: 'live chat offline',
    initiated: 'live chat initiated',
    submitted: 'live chat submitted',
} as const;
type LiveChatEventAction = (typeof LIVE_CHAT_ACTION_MAP)[keyof typeof LIVE_CHAT_ACTION_MAP];

type Placement = 'checkout' | 'pdp';

type SetUpArgs = {
    placement: Placement;
    defaultLabel: string;
};

type Args = {
    label?: string;
    action: LiveChatEventAction;
    isInteractiveEvent: boolean;
};

export const liveChatTracking =
    ({ placement, defaultLabel }: SetUpArgs) =>
    ({ label, action, isInteractiveEvent }: Args): void => {
        trackEvent({
            category: CATEGORY,
            label: label || defaultLabel,
            interaction_type: `${placement} - live chat`,
            eventName: eventNameConstants.EVENT_CONTACT_1STDIBS,
            action,
            step_interaction_name: action,
            isInteractiveEvent,
        });
    };

export const trackLiveChatSubmitEvent = (): void =>
    trackEvent({
        action: LIVE_CHAT_ACTION_MAP.submitted,
        category: 'contact 1stdibs',
        event: 'e_ga_event',
        eventName: eventNameConstants.EVENT_CONTACT_1STDIBS,
        interaction_type: 'live chat',
        isInteractiveEvent: true,
        step_interaction_name: LIVE_CHAT_ACTION_MAP.submitted,
    });
